import type { IRole } from '@/models/IRole'
import type { IRolePermission } from '@/models/IRolePermission'
import { EmptyRole } from '@/models/IRole'
import {
    EmptySubscriptionBundleAlertConfiguration,
    ISubscriptionBundleAlertConfiguration,
} from './bundle/ISubscriptionBundleAlertConfiguration'

export interface IUser {
    badge_color: string
    category: string
    client_name?: string
    client_space_name?: string
    email: string
    phone?: string
    first_name: string
    id_client?: number
    id_professional: number
    id_role?: number
    id_user: number
    initial: string
    language: string
    last_name: string
    professional_name?: string
    date_certified_mail?: string
    date_associate?: string
    date_invitation?: string
    date_creation?: string
    date_resend_invitation?: string
    id_user_invitation?: number
    id_sign_up_link?: number
    statut: number
    role: IRole
    role_permissions: IRolePermission[]
    alert_badge: boolean
    alert_push: boolean
    alert_mail: boolean
    alert_sms: boolean
    do_not_disturb: boolean
    subscription_bundle_alert_configuration: ISubscriptionBundleAlertConfiguration | null
}

export const EmptyUser: IUser = {
    alert_badge: true,
    alert_mail: true,
    alert_push: false,
    alert_sms: false,
    do_not_disturb: false,
    badge_color: '',
    category: '',
    client_name: '',
    client_space_name: '',
    date_certified_mail: '',
    date_associate: '',
    date_invitation: '',
    email: '',
    first_name: '',
    id_client: 0,
    id_professional: 0,
    id_role: 0,
    id_user: 0,
    initial: '',
    language: '',
    last_name: '',
    professional_name: '',
    statut: 0,
    role_permissions: [],
    role: EmptyRole,
    subscription_bundle_alert_configuration: EmptySubscriptionBundleAlertConfiguration,
}
